import React from 'react';
import { useNavigate } from 'react-router-dom';

export default function ContentAction({ action, children, ...props }) {
  const navigate = useNavigate();
  const open = () => {
    if (action.disabled) return;
    if (action.external) window.open(action.href, '_blank', 'noopener,noreferrer');
    else navigate(action.href);
  };
  return <button {...props} type="button" disabled={action.disabled} onClick={open}>{children}</button>;
}
